import {Component} from 'preact';

const SECOND = 1000,
      MINUTE = SECOND * 60,
      HOUR = MINUTE * 60,
      DAY = HOUR * 24;
const DATE = new Date('December 4, 2020 19:00:00').getTime();

export default class Timer extends Component {
  constructor(props){
    super(props);
    this.state = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
    this.calculeteTime = this.calculeteTime.bind(this);
  }

  calculeteTime() {
    const distance = this.countDown - new Date().getTime();
    this.setState({
      days: Math.floor(distance / DAY),
      hours: Math.floor((distance % DAY) / HOUR),
      minutes: Math.floor((distance % HOUR) / MINUTE),
      seconds: Math.floor((distance % MINUTE) / SECOND),
    });
  }

  componentDidMount() {
    this.countDown = DATE;
    this.timer = setInterval(this.calculeteTime, SECOND);
  }

  render() {
    const {days, hours, minutes, seconds} = this.state
    const splitFigures = (figure) => {
      return (
        <div className="timer__figure">
          <span className="digit">{(figure >= 0) ? Math.floor(figure / 10) : 0}</span>
          <span className="digit">{(figure >= 0) ? figure % 10 : 0}</span>
        </div>
      )
    }

    return (
      <div className="timer">
        <div class="timer__header">До запуска проекта осталось: </div>
        <div className="timer__body">
          <div className="timer__figure-container">
            {splitFigures(days)}
            <div className="timer__figure-name">Дни</div>
          </div>
          <div className="timer__figure-container">
            {splitFigures(hours)}
            <div className="timer__figure-name">Часы</div>
          </div>
          <div className="timer__figure-container">
            {splitFigures(minutes)}
            <div className="timer__figure-name">Минуты</div>
          </div>
          <div className="timer__figure-container">
            {splitFigures(seconds)}
            <div className="timer__figure-name">Секунды</div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/timer/index.js